(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$.fn.dynamicFontSize = function (min) {
		var minFontSize = min || 12;

		return this.each(function () {
			var el = $(this);
			var fontSize = parseInt(el.css('font-size'), 10);

			var isTooWide = function () {
				var scrollWidth = el[0].scrollWidth;
				var innerWidth = el.innerWidth();

				if (scrollWidth > innerWidth) {
					return true;
				}

				return false;
			};

			// Only continue if white-space: nowrap
			if (el.css('white-space') == 'nowrap') {
				while (isTooWide() && fontSize > minFontSize) {
					fontSize *= 0.95;

					el.css('font-size', fontSize + 'px');
				}
			}
		});
	};

	$(window).load(function () {
		$('.dynamic-font-size').dynamicFontSize(20);
	});
})();
